/**用车选择车辆***/
<template>
  <div class="carType" :class="state?'carTypeShow':''">
    <div class="carTypeCont">
      <div class="title">
        已选择
        <span class="allNum">{{ZcQueryCar.allNum}}</span>
        辆
      </div>
      <div class="content">
        <div v-if="ZcQueryCar && ZcQueryCar.data && ZcQueryCar.data.length>0">
          <div class="row clear" v-for="(item,index) in ZcQueryCar.data"
               @click="radioFn({type:'radio',name:item.name,id:item.id,radio:radio,index:index,num:item.num})">
          <span class="remove"
                @click.stop="selectFn({type:'minus',name:item.name,id:item.id})"
                v-if="acNum===index && ZcQueryCar.allNum>1 && item.num >= 1 && !radio">
          <i class=" iconfont  icon-jian"></i>
        </span>
            <span class="val">
          <span class="name">
            {{item.name}}
          </span>
          <span class="num" v-if="item.num>0">
            <b>{{item.num}}</b>
            辆
          </span>
        </span>
            <span class="push"
                  @click.stop="selectFn({type:'plus',name:item.name,id:item.id,radio:radio})"
                  v-if="acNum===index && item.num<ZcQueryCar.maxNum &&ZcQueryCar.allNum<10&&!radio">
                <i class=" iconfont  icon-jia"></i>
        </span>
          </div>
        </div>
        <div class="wucheliang" v-else="">
          <h2>该公司暂无车辆</h2>
        </div>
      </div>
      <div class="bottom clear">
        <span class="but reset" :class="ZcQueryCar.allNum>0?'resetShow':''" @click="selectFn({type:'reset'})">
          重置
        </span>
        <span class="but affirm" @click="affirmFn">
          确定选择
        </span>
      </div>
    </div>
    <div v-if="state" class="modal" @click="affirmFn"></div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    components: {},
    name: 'xk-carType',
    props: ['data', 'radio'],
    computed: {
      ...mapGetters({
        ZcQueryCar: 'ZcQueryCar'
      })
    },
    data () {
      return {
        carInfo: this.$props.data,
        state: false,
        acNum: null
      }
    },
    methods: {
      selectFn: function (obj) {
        if (obj.type === 'reset') {
          this.acNum = null
        }
        this.$store.dispatch('ZcCarTypeSelect', obj)
        this.$emit('click')
      },
      affirmFn: function () { //
        this.state = !this.state
        this.$emit('click')
      },
      radioFn: function (obj) {
        let that = this
        if (obj.radio) {
          that.$store.dispatch('ZcCarTypeSelect', obj)
          this.$emit('click')
          return false
        }
        if (obj.type === 'radio' && obj.num < 1) {
          obj.type = 'plus'
          that.$store.dispatch('ZcCarTypeSelect', obj)
        }
        that.acNum = obj.index
      }
    },
    mounted: function () {
      this.$emit('click')
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .carType {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: -100;
    .carTypeCont {
      position: absolute;
      bottom: -100%;
      left: 0;
      width: 100%;
      background-color: #fff;
      z-index: 200;
      line-height: 3.75rem;
      text-align: center;
      transition: 0.3s all;
      opacity: 0;
      .title {
        color: #999999;
        font-size: 1.25rem;
        border-bottom: 1px solid #eee;
      }
      .content {
        max-height: 15rem;
        overflow-y: scroll;
        .row {
          box-sizing: border-box;
          padding: 0 1rem;
          width: 100%;
          height: 3.75rem;
          overflow: hidden;
          border-bottom: 1px solid #eee;
          position: relative;
          .remove, .push {
            position: relative;
            width: 2.5rem;
            height: 100%;
            i {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              color: #4c4c4c;
            }
          }
          .remove {
            float: left;
          }
          .push {
            float: right;
          }
          .val {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: #333333;
            .num {
              b {
                color: #f06553;
                font-size: 1.5rem;
                margin: 0 0.2rem;
              }
            }
          }
        }
      }
      .bottom {
        width: 100%;
        .but {
          width: 50%;
          text-align: center;
          float: left;
          font-size: 1.25rem;
        }
        .reset {
          color: #bcbcbc;
          background-color: #eee;
        }
        .affirm {
          color: #fff;
          background-color: #f06553;
        }
        .resetShow {
          color: #f06553;
        }
      }
    }
    .wucheliang {
      h2 {
        text-align: center;
      }
    }
    .modal {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 100;
    }
  }

  .carTypeShow {
    z-index: 300;
    opacity: 1;
    .carTypeCont {
      bottom: 0;
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// carType.vue?681e92fe